import { adaptFilters } from './requestAdapters';

/** Transforms the state into the expected query for the search API call */
export const transformSearchUIStateToQuery = (state: {
  searchTerm: string;
  filters: string[];
  current: number;
  resultsPerPage: number;
  sortField: string;
  sortDirection: string;
}) => {
  return {
    query: state.searchTerm,
    filters: adaptFilters(state.filters),
    page: {
      current: state.current,
      size: state.resultsPerPage,
    },
    sort:
      state.sortField && state.sortDirection
        ? {
            [state.sortField]: state.sortDirection,
          }
        : undefined,
  };
};

/** Transforms the state into the expected query for the suggestions API call */
export const transformSuggestionUIStateToQuery = (state: {
  searchTerm: string;
}) => {
  return {
    query: state.searchTerm,
    size: 5,
  };
};

/** Transforms the state into the expected query for the cick API call */
export const transformClickResultsUIStateToQuery = (state: {
  query: string;
  documentId: string;
  requestId: string;
  filters: Array<any>;
}) => {
  return {
    query: state.query,
    document_id: state.documentId,
    request_id: state.requestId,
  };
};
